import React from "react";
import LoadingSpinner from "../../../Loading/component";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import "./ProductVariantDetails.css";
import Button from "@mui/material/Button";
import { useNavigate, useParams } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { Chip } from "@mui/material";

const ProductVariantDetailsComponent = (props) => {
  const { variantId } = useParams();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1);
  };

  const handleCreateMfids = (variantId) => {
    if (variantId) {
      navigate(`/home/configuration/productsvariantdetails/createmfid/${variantId}`);
    }
  };

  const handleUpdateMfids = (variant) => {
    if (variant && variant.id) {
      navigate(
        `/home/configuration/productsvariantdetails/updatemfid/${variant.id}/${variantId}`,
        { state: { variant } }
      );
    }
  };

  return (
    <div className="pvd-container">
      <div className="pvd-sidebar-wrapper">
        <Sidebar />
      </div>

      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="pvd-main-content">
          <div className="pvd-content-wrapper">
            {/* Header */}
            <div className="pvd-header">
              <div className="pvd-title-section">
                <img
                  onClick={handleClick}
                  className="pvd-back-button"
                  src={leftArrow}
                  alt="Back"
                />
                <h3 className="pvd-product-name">
                  {props.productData?.productName || "Product Details"}
                </h3>
              </div>

              <Button
                className="pvd-create-btn"
                onClick={() => handleCreateMfids(props.productData?.variantId)}
              >
                Create New MFID
              </Button>
            </div>

            {/* Product Info */}
            <div className="pvd-info-card">
              <div className="pvd-image-section">
                {props.productData?.variantImages?.[0]?.imageId ? (
                  <img
                    className="pvd-product-img"
                    alt="Product"
                    src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${props.productData.variantImages[0].imageId}`}
                  />
                ) : (
                  <div className="pvd-img-placeholder">No Image</div>
                )}
              </div>

              <div className="pvd-details-section">
                <div className="pvd-detail-row">
                  <span className="pvd-detail-label">Variant ID : </span>
                  <Chip 
                    label={props.productData?.variantId || "N/A"} 
                    size="small"
                    sx={{ 
                      backgroundColor: '#E8F0FE',
                      fontWeight: 600,
                      color: '#3282FF',
                      fontSize: '0.75rem'
                    }}
                  />
                </div>
                <div className="pvd-detail-row">
                  <span className="pvd-detail-label">Brand Name : </span>
                  <span className="pvd-detail-value">{props.productData?.brandName || "N/A"}</span>
                </div>
                <div className="pvd-detail-row">
                  <span className="pvd-detail-label">Product Name : </span>
                  <span className="pvd-detail-value">{props.productData?.productName || "N/A"}</span>
                </div>
                <div className="pvd-detail-row">
                  <span className="pvd-detail-label">M.R.P : </span>
                  <span className="pvd-detail-value">
                    <CurrencyRupeeIcon className="pvd-currency-icon" />
                    {props.productData?.variantMrp &&
                    props.productData.variantMrp.minMrp !== null &&
                    props.productData.variantMrp.maxMrp !== null
                      ? props.productData.variantMrp.minMrp ===
                        props.productData.variantMrp.maxMrp
                        ? `${props.productData.variantMrp.minMrp}`
                        : `${props.productData.variantMrp.minMrp} - ${props.productData.variantMrp.maxMrp}`
                      : "N/A"}
                  </span>
                </div>
              </div>
            </div>

            {/* MFID Count */}
            <div className="pvd-count-section">
              <p className="pvd-count-text">
                MFIDs (<span>{props.mfidCountData?.mfIdCount || 0}</span>)
              </p>
            </div>

            {/* MFID List */}
            <div className="pvd-list-container">
              {props.manufacturerVariantData &&
              props.manufacturerVariantData.length > 0 ? (
                props.manufacturerVariantData.map((item) => (
                  <div key={item.id} className="pvd-card">
                    <div className="pvd-card-content">
                      <div className="pvd-card-details">
                        <div className="pvd-card-header">
                          <span className="pvd-card-id">MFID: {item.id}</span>
                          <Button
                            className="pvd-edit-btn"
                            variant="outlined"
                            onClick={() => handleUpdateMfids(item)}
                          >
                            Edit
                          </Button>
                        </div>

                        <div className="pvd-details-grid">
                          <div className="pvd-detail-row">
                            <span className="pvd-detail-label">Vendor : </span>
                            <span className="pvd-detail-value">
                              {item.manufacturerName || "N/A"}
                            </span>
                          </div>
                          <div className="pvd-detail-row">
                            <span className="pvd-detail-label">Purchase Type : </span>
                            <span className="pvd-detail-value">
                              <Chip 
                                label={item.purchaseType || "N/A"} 
                                size="small"
                                sx={{ 
                                  backgroundColor: '#F0F4F8',
                                  fontSize: '0.7rem',
                                  fontWeight: 500
                                }}
                              />
                            </span>
                          </div>
                          <div className="pvd-detail-row">
                            <span className="pvd-detail-label">M.R.P : </span>
                            <span className="pvd-detail-value">
                              <CurrencyRupeeIcon className="pvd-currency-icon" />
                              {item.mrp || "N/A"}
                            </span>
                          </div>
                          <div className="pvd-detail-row">
                            <span className="pvd-detail-label">Purchase Price : </span>
                            <span className="pvd-detail-value">
                              <CurrencyRupeeIcon className="pvd-currency-icon" />
                              {item.vendorPrice || "N/A"}
                            </span>
                          </div>
                        </div>
                        
                        <div className="pvd-selling-container">
                          <div className="pvd-selling-overlay">
                            <span className="pvd-selling-label">Selling Price : </span>
                            <span className="pvd-selling-value">
                              <CurrencyRupeeIcon 
                                sx={{ 
                                  width: '16px', 
                                  height: '16px',
                                  verticalAlign: 'middle' 
                                }} 
                              />
                              {item.offerPrice || "N/A"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="pvd-empty-card">
                  <div className="pvd-empty-message">No MFID found for this product</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductVariantDetailsComponent;